// const originalFetch = window.fetch;

// const myApiDomains = [
// ];

// window.fetch = async (url, options = {}) => {
//   const accessToken = localStorage.getItem("accessToken"); // Or sessionStorage, cookie, etc.

//   options.headers = {
//     ...options.headers,
//     ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
//     ...(options.body instanceof FormData
//       ? {}
//       : { "Content-Type": "application/json" }),
//   };

//   return await window.originalFetch(url, options);
// };

import { toast } from "react-toastify";
import { GenerateJWTTokens } from "./Services/APIService";

const originalFetch = window.fetch;

const myApiDomains = [
  "https://adminmodule.kpostindia.com",
  "https://devapi2.kpostindia.com/v2",
  "http://192.168.2.24:9092",
  "http://192.168.2.41:9092",

];

// window.fetch = async (url, options = {}) => {
//   // options.headers = {
//   //   "Content-Type": "application/json",
//   //   ...options.headers,
//   // };
// const accessToken = localStorage.getItem("accessToken");
//   options.headers = {
//     ...options.headers,
//      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
//     ...(options.body instanceof FormData
//       ? {}
//       : { "Content-Type": "application/json" }),
//   };

//   // Check if URL belongs to your APIs
//   const isMyApiRequest = myApiDomains.some((domain) => url.startsWith(domain));

//   if (!isMyApiRequest) {
//     // Bypass third-party APIs
//     return originalFetch(url, options);
//   }
//   console.log(url, options, "interceptFetch");
//   // Check if Authorization header is present
//   const hasAuthorizationHeader = options.headers.Authorization;

//   try {
//     let response = await originalFetch(url, options);

//     if (response.status === 401 && hasAuthorizationHeader) {
//       const errorData = await response.json();
//       const errorMessage = errorData.debugMessage;
//       console.log(errorData, "CheckRes");
//       if (errorMessage === "Token has expired") {
//         // alert("May be Token Gets Expired!");
//         const newToken = await TokenValidationFunc();
//         if (newToken) {
//           const updatedOptions = {
//             ...options,
//             headers: {
//               ...options.headers,
//               Authorization: `Bearer ${newToken}`,
//             },
//           };

//           response = await originalFetch(url, updatedOptions);
//         } else {
//           // If token refresh fails, handle logout
//           handleLogout();
//           throw new Error("Unauthorized - Token refresh failed");
//         }
//       } else {
//         handleLogout();
//         throw new Error("Unauthorized");
//       }
//     }

//     return response;
//   } catch (error) {
//     console.error(error.message);
//     throw error;
//   }
// };

window.fetch = async (url, options = {}) => {
  const accessToken = localStorage.getItem("accessToken");

  options.headers = {
    ...options.headers,
    // ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
  };

  const isMyApiRequest = myApiDomains.some((domain) => url.startsWith(domain));

  if (!isMyApiRequest) {
    return originalFetch(url, options);
  }

  // Use a custom retry flag to avoid infinite loop
  const hasRetried = options._retry;

  try {
    let response = await originalFetch(url, options);

    if (response.status === 401 && options.headers.Authorization && !hasRetried) {
      const errorData = await response.json();
      const errorMessage = errorData.debugMessage;

      if (errorMessage === "Token has expired") {
        const newToken = await TokenValidationFunc();

        if (newToken) {
          const updatedOptions = {
            ...options,
            _retry: true, // Mark this request as retried
            headers: {
              ...options.headers,
              Authorization: `Bearer ${newToken}`,
            },
          };

          return originalFetch(url, updatedOptions);
        } else {
          handleLogout();
          throw new Error("Unauthorized - Token refresh failed");
        }
      } else {
        handleLogout();
        throw new Error("Unauthorized");
      }
    }

    return response;
  } catch (error) {
    console.error(error.message);
    throw error;
  }
};


function handleLogout() {
  window.location.href = "/login";
  localStorage.clear();
  // localStorage.setItem("someoneLoggedIn", true);
}

function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

async function TokenValidationFunc() {
  const accessToken = localStorage.getItem(`accessToken`);
  const refreshToken = localStorage.getItem(`refreshToken`);
  const decodedJwt = parseJwt(accessToken);
  const decodedReFresh = parseJwt(refreshToken);
  console.log(decodedJwt, "TOKVAL");
  if (decodedReFresh.exp * 1000 < Date.now()) {
    window.location.href = "/login";
    localStorage.clear();
  } else {
    if (decodedJwt.exp * 1000 < Date.now()) {
      if (refreshToken) {
        const bod = { refreshToken };
        try {
          const response = await GenerateJWTTokens(bod);
          if (response.status === "SUCCESS") {
            localStorage.setItem("accessToken", response?.accessToken);
            localStorage.setItem("userRefToken", response?.refreshToken);
            // window.location.reload();
            return response?.accessToken;
          } else {
            // localStorage.clear();
          }
        } catch (error) {
          console.error("Error during token refresh:", error);
          // localStorage.clear();
        }
      }
    }
  }
}
